module.exports = __webpack_public_path__ + "static/media/place.b4ba4b4f.svg";